import {Component, Inject, Vue, Watch} from "vue-property-decorator";
import {PageTitle} from "~/components/page-title";
import {icons} from "~/components/icon";
import {MainContainer} from "~/components/main-container";
import {Getter} from "vuex-class";
import {ClientsList} from "~/modules/partner/components/clients-list";
import {AppSettings} from "~/lib/app-settings";

@Component
class PartnerView extends Vue {
  @Getter currentUser;
  @Inject() appSettings: AppSettings;

  created() {
    // Reset last client selection
    this.appSettings.client = null;
  }

  get hasClients() {
    return this.appSettings.hasClients;
  }

  @Watch('hasClients')
  async onHasClientChange(next) {
    if (next === false) {
      await this.$router.push({ name: 'home', params: { clientUuid: this.currentUser.client }});
    }
  }

  private renderClientsListing() {
    return <ClientsList />;
  }

  render() {
    return (
      <MainContainer>
        <PageTitle icon={icons.allUsers} title="Comptes clients"/>
        {this.appSettings.hasClients && (
          <div class="page-content">
            {this.renderClientsListing()}
          </div>
        )}
      </MainContainer>
    )
  }
}

export { PartnerView }

// VUE JSX HOT LOADER //
if (module.hot) require("/usr/src/app/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-502ba9b8/partner-view.tsx" });